import React from 'react';
import Button from 'jbc-front/components/Button';
import { useMutation, useQuery } from '../components/Graphql';
import { gql } from '@apollo/client';
import { Panel, Headding, Item, Lead, Description, Buttons } from '../components/PrimaryPanel';
import LoadingPage from '../components/LoadingPage';
import useReactRouter from 'use-react-router';
import { CustomDescription } from '../components/QuestionDescription';

const ANSWER_SALARY_MORE = gql`
  mutation answerSalaryMore($answer: Boolean!) {
    answerSalaryMore(input: { salaryMoreThanOthers: $answer }) {
      questions {
        id
        status
      }
      request {
        id
        profile {
          id
          salaryMoreThanOthers
          needAdjThisYear
          nextYearOnly
        }
      }
    }
  }
`;

const EMPLOYEE_OFFICE = gql`
  query employeeOffice {
    request {
      id
      employee {
        id
        office {
          id
          name
        }
      }
    }
  }
`;

const Question = ({ dispatch }) => {
  const { loading, data } = useQuery(EMPLOYEE_OFFICE);
  const [answer, { loadingAnswer }] = useMutation(ANSWER_SALARY_MORE);
  const { history } = useReactRouter();
  if (loading) return <LoadingPage />;
  const {
    request: {
      employee: { office }
    }
  } = data;
  return (
    <Panel>
      <Headding>今年の給与</Headding>
      <Item>
        <Lead>
          お給料は
          {office?.name || 'こちらの会社'}
          の方が高いですか？
        </Lead>
        <CustomDescription field="top" />
        <Buttons>
          <Button
            huge
            secondary
            disabled={loadingAnswer}
            onClick={async () => {
              await answer({ variables: { answer: true } });
              history.push('/employee_input');
            }}
          >
            はい
          </Button>
          <Button
            huge
            secondary
            disabled={loading}
            onClick={async () => {
              await answer({ variables: { answer: false } });
              history.push('/employee_input');
            }}
          >
            いいえ
          </Button>
        </Buttons>
      </Item>
    </Panel>
  );
};

export default Question;
